// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__2Q5AZ","column-actions":"Table_column-actions__v2PBr","tdWithIcon":"Table_tdWithIcon__1F5SS"};